import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = { site_name: "HK Forexedge", logo_url: "/logo.png", favicon_url: "/favicon.png" };
const BrandingContext = createContext({ branding: DEFAULTS, publicConfig: {}, refresh: () => {} });
export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);
  const [publicConfig, setPublicConfig] = useState({ signals_enabled: true, signals_trial_enabled: true, signals_trial_days: 7 });

  const load = () => api.get("/settings/branding").then((r) => setBranding((b) => ({ ...b, ...r.data }))).catch(() => {});
  useEffect(() => {
    load();
    api.get("/settings/public-config").then((r) => setPublicConfig((c) => ({ ...c, ...r.data }))).catch(() => {});
  }, []);

  useEffect(() => {
    if (branding.site_name) document.title = `${branding.site_name} — Account-bound Trading Tools`;
    if (branding.favicon_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = branding.favicon_url;
    }
  }, [branding.site_name, branding.favicon_url]);

  // Keep the page meta description (and social cards) in sync with the
  // admin-editable "Meta description" branding field. Per-page <Seo> tags still
  // override this on pages that set their own description.
  useEffect(() => {
    const desc = branding.meta_description;
    if (!desc) return;
    const apply = (selector, attr, key) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", desc);
    };
    apply('meta[name="description"]', "name", "description");
    apply('meta[property="og:description"]', "property", "og:description");
    apply('meta[name="twitter:description"]', "name", "twitter:description");
  }, [branding.meta_description]);

  return <BrandingContext.Provider value={{ branding, publicConfig, refresh: load }}>{children}</BrandingContext.Provider>;
}
